const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://musthost.com.br';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'musthost',
  legalName: 'musthost LTDA',
  url: SITE_URL,
  logo: {
    '@type': 'ImageObject',
    url: 'https://musthost.com.br/img/logo.png',
    width: 300,
    height: 300,
  },
  image: 'https://musthost.com.br/img/logo.png',
  description:
    'musthost é uma empresa especializada em VPS de alta performance para traders, desenvolvedores e empresas desde 2008. Data centers no Brasil, Reino Unido e Estados Unidos. Uptime garantido, suporte 24/7 em PT-BR e EN e migração gratuita.',
  foundingDate: '2008',
  foundingLocation: {
    '@type': 'Place',
    name: 'Fortaleza, Ceará, Brasil',
  },
  taxID: '12.884.720/0001-46',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Av. Des. Moreira, 1.300, Sala 602 — Aldeota',
    addressLocality: 'Fortaleza',
    addressRegion: 'CE',
    postalCode: '60170-002',
    addressCountry: 'BR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: -3.7327,
    longitude: -38.527,
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      telephone: '+55-85-98699-0114',
      email: 'vendas@musthost.com.br',
      availableLanguage: [
        { '@type': 'Language', name: 'Portuguese' },
        { '@type': 'Language', name: 'English' },
      ],
      hoursAvailable: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday',
        ],
        opens: '00:00',
        closes: '23:59',
      },
      areaServed: 'Worldwide',
    },
    {
      '@type': 'ContactPoint',
      contactType: 'sales',
      telephone: '+55-85-98699-0114',
      email: 'vendas@musthost.com.br',
      contactOption: 'TollFree',
      availableLanguage: [
        { '@type': 'Language', name: 'Portuguese' },
      ],
    },
  ],
  employee: [
    {
      '@type': 'Person',
      name: 'Felipe Pinheiro',
      jobTitle: 'Diretor Executivo (CEO)',
      worksFor: { '@type': 'Organization', name: 'musthost' },
    },
  ],
  sameAs: [
    'https://www.youtube.com/@musthost',
    'https://www.instagram.com/musthost',
    'https://www.linkedin.com/company/musthost',
    'https://musthost.com.br',
  ],
  priceRange: 'R$ 39 - R$ 999',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Planos VPS musthost',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'VPS para Traders',
          description: 'Servidores VPS de ultra-baixa latência para operações de day trade no Brasil, Reino Unido e EUA.',
          url: `${SITE_URL}/traders`,
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'VPS para Desenvolvedores',
          description: 'VPS Linux otimizado para desenvolvimento, deploy e aplicações web.',
          url: `${SITE_URL}/vps-dev`,
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'VPS Empresa',
          description: 'Infraestrutura VPS dedicada para empresas com SLA corporativo e suporte prioritário.',
          url: `${SITE_URL}/vps-empresa`,
        },
      },
    ],
  },
  knowsAbout: [
    'VPS Hosting',
    'Cloud Infrastructure',
    'Day Trading Servers',
    'Low Latency Networking',
    'Data Center Management',
    'Linux Servers',
    'Tier 3 Data Centers',
  ],
};